import { render, staticRenderFns } from "./EditCertificateList.vue?vue&type=template&id=1928b79c"
import script from "./EditCertificateList.vue?vue&type=script&lang=ts"
export * from "./EditCertificateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports